import { getRequest } from '@/utils/axios'

export const getTrades = params => {
  return getRequest('/api/trades', params)
}
